module.exports = __webpack_public_path__ + "img/42.d0e6dc23.png";